module.exports = __webpack_public_path__ + "img/atsResume.e8cde685.svg";